import Record from "slotworks/model/gameplay/records/record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";
import { HoldAndSpinScatterResult } from "ags/integration/model/results/hold-and-spin-scatter-result";
import { HoldAndSpinRecord } from "ags/integration/records/hold-and-spin-record";

class LLBonusScatterSubstituteSupplement implements DataProcessorSupplement {
    public process(record: Record): void {
        if (record && record instanceof HoldAndSpinRecord) {
            const scatterResults = record.getResultsOfType(HoldAndSpinScatterResult);
            for (const scatterResult of scatterResults) {
                const jackpotTier = scatterResult.jackpotTier;
                const label = jackpotTier ? jackpotTier : scatterResult.winAmount;
                record.grid[scatterResult.reel][0] = `TT_${label}`;
            }
        }
    }
}

export default new LLBonusScatterSubstituteSupplement();
